import React, { useState, useEffect } from 'react';
import { get } from '../../../Utils/Crypto';
import { useSelector } from 'react-redux';

const Index = ({ tenant}) => {

    let config = useSelector(state=>state.auth.config);
    const [isVisible, setIsVisible] = useState(true);
    const [isAnimated, setIsAnimated] = useState(false);

    let tenantList = ["DTDC","INDIAN","TCHMT","Purplle","AVENDUS","NYKAA","FRIDO","SFR","UDAAN","Pureplay","XPRSBS","INCRED","BAJEL","EDME","NAVI","TGRANAL","TGRANL","ZOLO","SBFC","CTYML","AKSH"]

    useEffect(() => {
        // Trigger animation after component mounts
        setTimeout(() => setIsAnimated(true), 100);
    }, []);

    if(!tenantList.includes(tenant) || !isVisible){
        return null;
    }

    const handleClose = () => {
        setIsAnimated(false);
        setTimeout(() => setIsVisible(false), 300);
    }

    const bannerStyles = {
        height: 'auto',
        minHeight: 60,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        zIndex: 1111,
        top: 0,
        right: 0,
        fontSize: 14,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: "#fff",
        padding: '12px 20px',
        transform: isAnimated ? 'translateY(0)' : 'translateY(-100%)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontWeight: '500',
        position: 'relative',
        overflow: 'hidden'
    };

    const textContainerStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '8px',
        maxWidth: '800px',
        textAlign: 'center',
        position: 'relative',
        zIndex: 2
    };

    const linkStyles = {
        color: '#fff',
        textDecoration: 'none',
        fontWeight: '600',
        padding: '8px 16px',
        borderRadius: '20px',
        background: 'rgba(255,255,255,0.2)',
        border: '1px solid rgba(255,255,255,0.3)',
        transition: 'all 0.3s ease',
        backdropFilter: 'blur(5px)',
        marginLeft: '10px',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px'
    };

    const closeButtonStyles = {
        position: 'absolute',
        top: '50%',
        right: '15px',
        transform: 'translateY(-50%)',
        background: 'rgba(255,255,255,0.2)',
        border: 'none',
        borderRadius: '50%',
        width: '30px',
        height: '30px',
        color: '#fff',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        fontSize: '16px',
        fontWeight: 'bold',
        backdropFilter: 'blur(5px)',
        zIndex: 3
    };

    const sparkleStyles = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)',
        animation: 'shimmer 3s infinite',
        pointerEvents: 'none'
    };

    return (
        <>
            <style>
                {`
                @keyframes shimmer {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }
                
                @keyframes pulse {
                    0%, 100% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                }
                
                .banner-link:hover {
                    background: rgba(255,255,255,0.3) !important;
                    transform: translateY(-1px) !important;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.2) !important;
                }
                
                .close-btn:hover {
                    background: rgba(255,255,255,0.3) !important;
                    transform: translateY(-50%) scale(1.1) !important;
                }
                
                .banner-icon {
                    animation: pulse 2s infinite;
                }
                
                @media (max-width: 768px) {
                    .banner-text {
                        flex-direction: column;
                        gap: 12px;
                    }
                }
                `}
            </style>
            <div style={bannerStyles}>
                <div style={sparkleStyles}></div>
                
                <div style={textContainerStyles} className="banner-text">
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <span role="img" aria-label="sparkle" className="banner-icon" style={{fontSize: '18px'}}>✨</span>
                        <span>Experience the new UI for Corporate Dashboard</span>
                    </div>
                    
                    <a 
                        href={`https://corporate.dice.tech/nroute?grant_type=redirect&access_token=${get('token')}&name=${config.name}&refresh_token=${get('refresh_token')}&token_type=bearer}`} 
                        target="_blank" 
                        style={linkStyles}
                        className="banner-link"
                        rel="noopener noreferrer"
                        onMouseEnter={(e) => {
                            e.target.style.background = 'rgba(255,255,255,0.3)';
                            e.target.style.transform = 'translateY(-1px)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = 'rgba(255,255,255,0.2)';
                            e.target.style.transform = 'translateY(0)';
                        }}
                    >
                        <span>Click Here</span>
                        <span style={{fontSize: '12px'}}>→</span>
                    </a>
                </div>
                
                <button 
                    style={closeButtonStyles}
                    className="close-btn"
                    onClick={handleClose}
                    onMouseEnter={(e) => {
                        e.target.style.background = 'rgba(255,255,255,0.3)';
                        e.target.style.transform = 'translateY(-50%) scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = 'rgba(255,255,255,0.2)';
                        e.target.style.transform = 'translateY(-50%) scale(1)';
                    }}
                    title="Close banner"
                >
                    ×
                </button>
            </div>
        </>
    )
    
}

export default Index;